import { InputHTMLAttributes, ReactNode, useRef } from 'react';
import { FlexContainer, FlexContainerProps } from 'shared/Typhography/flex-box';
import styled from 'styled-components';

const HiddenInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const DisabledLayout = styled.div`
  position: absolute;
  opacity: 0.7;
  background: black;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export interface FileSelectProps {
  accept?: InputHTMLAttributes<HTMLInputElement>['accept'];
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
  disabled?: InputHTMLAttributes<HTMLInputElement>['disabled'];
  multiple?: InputHTMLAttributes<HTMLInputElement>['multiple'];
  styling?: FlexContainerProps;
  children?: ReactNode;
}

export const FileSelect = ({
  styling,
  children,
  accept,
  onChange,
  disabled,
  multiple,
}: FileSelectProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <FlexContainer
      border={{ border: '2px dashed #A3A8AE' }}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      {...styling}
      position="relative"
    >
      <HiddenInput
        type="file"
        accept={accept}
        onChange={onChange}
        disabled={disabled}
        multiple={multiple}
        ref={inputRef}
      />
      {children}
      {disabled && <DisabledLayout />}
    </FlexContainer>
  );
};
